import AnchorLinks from 'Root/ui/components/AnchorLinks.js'
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'
import Header from 'Root/ui/components/Header.js'
import Faqs from 'Root/ui/components/Faqs.js'
import Modal from 'Root/ui/components/Modal.js'
import Employees from 'Root/ui/components/Employees.js'
import InfoCarousel from 'Root/ui/components/InfoCarousel.js'
import ServicesCarousel from 'Root/ui/components/ServicesCarousel.js'
import PressCarousel from 'Root/ui/components/PressCarousel.js'
import HeroCarousel from 'Root/ui/components/HeroCarousel.js'
import ScrollableTable from 'Root/ui/components/ScrollableTable.js'
import inViewport from 'Root/ui/components/InViewport.js'
import CookieBar from 'Root/ui/components/CookieBar.js'
import VideoModal from 'Root/ui/components/VideoModal.js'

document.addEventListener('DOMContentLoaded', () => {
    new AnchorLinks(document.body)

    document.querySelectorAll('.custom-select').forEach((elem) => {
        elem.CustomSelect = new CustomSelectUI(elem)
    })

    if (document.querySelector('.header')) {
        document.querySelector('.header').Header = new Header(document.querySelector('.header'))
    }

    document.querySelectorAll('.s-faqs').forEach((elem) => {
        elem.Faqs = new Faqs(elem)
    })

    document.querySelectorAll('.s-modal').forEach((elem) => {
        elem.Modal = new Modal(elem)
    })

    document.querySelectorAll('.s-employees').forEach((elem) => {
        elem.Employees = new Employees(elem)
    })

    document.querySelectorAll('.s-info-carousel').forEach((elem) => {
        elem.InfoCarousel = new InfoCarousel(elem)
    })

    document.querySelectorAll('.s-services').forEach((elem) => {
        elem.ServicesCarousel = new ServicesCarousel(elem)
    })

    document.querySelectorAll('.s-press-teaser').forEach((elem) => {
        elem.PressCarousel = new PressCarousel(elem)
    })

    document.querySelectorAll('.s-hero-carousel').forEach((elem) => {
        elem.HeroCarousel = new HeroCarousel(elem)
    })

    document.querySelectorAll('.b-article table').forEach((elem) => {
        elem.ScrollableTable = new ScrollableTable(elem)
    })

    document.querySelectorAll('.shadow-border, .circle-image').forEach((elem) => {
        elem.InViewport = new inViewport(elem)
    })

    document.querySelectorAll('.s-cookie-bar').forEach((elem) => {
        elem.CookieBar = new CookieBar(elem)
    })

    document.querySelectorAll('.s-video-modal').forEach((elem) => {
        elem.VideoModal = new VideoModal(elem)
    })

    setTimeout(() => {
        document.body.classList.add('dom-ready')
    })
})
